module.exports = __webpack_public_path__ + "img/icon2-light.8f9bb85a.png";